import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PageContainer, { GapSize } from "../components/PageContainer";
import PageSection from "../components/PageSection";
import { useDocumentMeta } from "../hooks/useDocumentMeta";

const NotFoundPage: React.FC = () => {
  useDocumentMeta({
    title: "Page Not Found",
    description:
      "The page you're looking for doesn't exist. Continue shopping at The Americana Company.",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer hasPadding gapSize={GapSize.Small}>
      <PageSection className="hero">
        <h1>Page Not Found</h1>
        <p>
          Well, this trail went cold. The page you&apos;re looking for
          doesn&apos;t exist or may have moved.
        </p>
      </PageSection>

      <PageSection className="flex flex-col items-center gap-4 py-4 text-center">
        <span
          className="playfair-text text-7xl font-bold text-brown-dark"
          aria-hidden="true"
        >
          404
        </span>
        <div className="flex flex-col sm:flex-row gap-3 mt-2">
          <Link to="/" className="btn-primary">
            Continue Shopping
          </Link>
          <Link to="/contact" className="page-section-link self-center">
            Contact Us
          </Link>
        </div>
      </PageSection>
    </PageContainer>
  );
};

export default NotFoundPage;
